import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Figure, LargeText, Panel } from '@studiometa/ui';
import { isDev } from './config.js';
import MainFrame from './components/MainFrame.js';
import Gallery from './components/Gallery.js';
import Expertises from './components/Expertises.js';
import ParallaxMedia from './components/ParallaxMedia.js';
import Shapes from './components/Shapes.js';
import Collages from './components/Collages.js';
import Header from './components/Header.js';
import Single from './components/Single.js';
import Archives from './components/Archives.js';
import Loader from './components/Loader.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *     DistortedPixels: Array<Promise<import('./components/DistortedPixels.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      MainFrame,
      Action,
      Figure,
      Gallery,
      Panel,
      LargeText,
      ParallaxMedia,
      Header,
      Expertises,
      Shapes,
      Collages,
      Single,
      Archives,
      Loader,
      Related: () => importWhenVisible(() => import('./components/Related.js'), 'Related'),
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      Video: () => importWhenVisible(() => import('./components/Video.js'), 'Video'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
      DistortedPixels: () =>
        importWhenVisible(() => import('./components/DistortedPixels.js'), 'DistortedPixels'),
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
